<template>
  <div class="moment-preview">
    <div class="moment-preview-head">
      <div>
        <strong>Preview Pesan</strong>
        <span>Simulasi tampilan WhatsApp</span>
      </div>
      <span class="moment-preview-badge">SIMULASI</span>
    </div>

    <div class="wa-preview-shell">
      <div class="wa-preview-top">
        <span class="wa-preview-avatar">
          <i class="fa fa-user"></i>
        </span>
        <div>
          <strong>{{ receiverName }}</strong>
          <small>contoh penerima</small>
        </div>
        <i class="fa fa-ellipsis-v wa-preview-more"></i>
      </div>

      <div class="wa-preview-chat">
        <div class="wa-preview-date">Hari ini</div>

        <div class="wa-preview-row">
          <div class="wa-preview-bubble">
            <div v-if="attachmentType === 'image' && attachmentUrl" class="wa-preview-image">
              <img :src="attachmentUrl" alt="Lampiran gambar" />
            </div>

            <div v-if="attachmentType === 'document' && attachmentUrl" class="wa-preview-document">
              <i class="fa fa-file-text-o"></i>
              <div>
                <strong>Lampiran file</strong>
                <span>Dokumen</span>
              </div>
            </div>

            <div
              v-if="safeHtml"
              class="wa-preview-text"
              v-html="safeHtml"
            ></div>
            <div v-else class="wa-preview-placeholder">
              Pesan akan tampil di sini...
            </div>

            <div class="wa-preview-time">
              <span>{{ previewTime }}</span>
              <i class="fa fa-check"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="moment-preview-note">
      <i class="fa fa-info-circle"></i>
      Preview adalah simulasi. Tampilan akhir dapat berbeda tergantung aplikasi WhatsApp penerima.
    </p>
  </div>
</template>

<script>
import {
  renderWhatsAppHtml,
  whatsappPreviewVariables,
  safeAttachmentUrl
} from "@/utils/whatsappMessage";

export default {
  name: "MomentPreview",
  props: {
    message: {
      type: String,
      default: ""
    },
    receiverName: {
      type: String,
      default: "John Wick"
    },
    imageUrl: {
      type: String,
      default: ""
    },
    messageType: {
      type: String,
      default: "text"
    },
    previewTime: {
      type: String,
      default: "10.00"
    }
  },
  computed: {
    safeHtml() {
      return renderWhatsAppHtml(this.message, whatsappPreviewVariables());
    },
    attachmentUrl() {
      return safeAttachmentUrl(this.imageUrl);
    },
    attachmentType() {
      if (!this.attachmentUrl) return "";
      if (this.messageType === "image" || this.messageType === "document") {
        return this.messageType;
      }
      return "";
    }
  }
};
</script>

<style scoped>
.moment-preview {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.moment-preview-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.moment-preview-head strong {
  display: block;
  color: #344054;
  font-size: 14px;
}

.moment-preview-head span {
  display: block;
  margin-top: 1px;
  color: #98a2b3;
  font-size: 11px;
}

.moment-preview-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  color: #b36b00 !important;
  background: #fff7e8;
  border: 1px solid #f2ce91;
  border-radius: 999px;
  font-size: 10px !important;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.wa-preview-shell {
  overflow: hidden;
  flex: 1;
  min-height: 390px;
  background: #efe7de;
  border: 1px solid #dfd8cf;
  border-radius: 14px;
}

.wa-preview-top {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  color: #ffffff;
  background: #075e54;
}

.wa-preview-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  color: #075e54;
  background: #d9fdd3;
  border-radius: 50%;
  font-size: 13px;
}

.wa-preview-top strong {
  display: block;
  color: #ffffff;
  font-size: 12px;
}

.wa-preview-top small {
  display: block;
  color: rgba(255, 255, 255, 0.75);
  font-size: 10px;
}

.wa-preview-more {
  margin-left: auto;
  color: rgba(255, 255, 255, 0.85);
}

.wa-preview-chat {
  min-height: 335px;
  padding: 14px 12px 20px;
  background-color: #efe7de;
  background-image: radial-gradient(rgba(120, 100, 80, 0.12) 0.7px, transparent 0.7px);
  background-size: 12px 12px;
}

.wa-preview-date {
  width: fit-content;
  margin: 0 auto 12px;
  padding: 3px 9px;
  color: #667085;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 5px;
  font-size: 10px;
  font-weight: 600;
}

.wa-preview-row {
  display: flex;
  justify-content: flex-end;
}

.wa-preview-bubble {
  position: relative;
  min-width: 150px;
  max-width: 92%;
  padding: 8px 9px 18px;
  color: #344054;
  background: #d9fdd3;
  border-radius: 9px 2px 9px 9px;
  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.08);
}

.wa-preview-text {
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.55;
}

.wa-preview-text >>> strong {
  font-weight: 700;
}

.wa-preview-text >>> em {
  font-style: italic;
}

.wa-preview-text >>> s {
  text-decoration: line-through;
}

.wa-preview-text >>> code {
  padding: 1px 3px;
  background: rgba(15, 23, 42, 0.06);
  border-radius: 3px;
  font-family: Consolas, Monaco, monospace;
  font-size: 11px;
  white-space: pre-wrap;
}

.wa-preview-placeholder {
  color: #7b8794;
  font-size: 12px;
  font-style: italic;
}

.wa-preview-time {
  position: absolute;
  right: 8px;
  bottom: 5px;
  display: flex;
  align-items: center;
  gap: 3px;
  color: #6b7c75;
  font-size: 9px;
}

.wa-preview-time .fa-check {
  color: #34b7f1;
  font-size: 9px;
}

.wa-preview-image {
  margin: -3px -4px 6px;
  overflow: hidden;
  border-radius: 6px;
}

.wa-preview-image img {
  display: block;
  width: 100%;
  max-height: 180px;
  object-fit: cover;
}

.wa-preview-document {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
  padding: 8px;
  color: #344054;
  background: rgba(255, 255, 255, 0.55);
  border-radius: 6px;
}

.wa-preview-document > i {
  color: #667085;
  font-size: 18px;
}

.wa-preview-document strong {
  display: block;
  font-size: 11px;
}

.wa-preview-document span {
  display: block;
  color: #667085;
  font-size: 10px;
}

.moment-preview-note {
  margin: 9px 0 0;
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.45;
}

.moment-preview-note i {
  margin-right: 4px;
  color: #2e90fa;
}
</style>



// WEBPACK FOOTER //
// src/views/automation/birthdayGreetings/components/MomentPreview.vue